<template>
  <footer>
    <div
      class="bg-gradient-to-r from-black to-sky-900 mx-auto px-4 sm:px-6 lg:px-8"
    >
      <div class="py-8 text-center text-sm text-white sm:text-left">
        <span class="block sm:inline text-white"
          >&copy; {{ year }} LLG, Inc.</span
        >
        <span class="block sm:inline text-white">All rights reserved.</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    const date = new Date();
    return {
      year: date.getFullYear(),
    };
  },
};
</script>

<style scoped></style>
